export default new Map<string, { var: string; cssVar?: string; assignDefault?: string[] }>([
  [
    'hintColor',
    {
      var: 'components.hint.states.default.color',
      cssVar: 'hint-color',
    },
  ],
  [
    'hintErrorColor',
    {
      var: 'components.hint.states.error.color',
      cssVar: 'hint-error-color',
    },
  ],
  [
    'hintFont',
    {
      var: 'components.hint.size.default.typography',
      cssVar: 'hint-font',
    },
  ],
]);
